export const YEARLY = "Yearly";
export const QUARTERLY = "Quarterly";
export const MONTHLY = "Monthly"
export const MELA_GRADES = ["pk","k","1","2"];
export const DURATION_MAPPING = {
    [YEARLY] : "year",
    [MONTHLY] : "month",
    [QUARTERLY]: "quarter"
}
export const FEATURES_DATA = {
    'mela': '4,000+ Math and Reading lessons',
    'math': '2,000+ Math Games',
    'ela': '2,000+ Reading lessons',
    'book': 'Books',
    'all_inclusive': '4,000+ Math and Reading games + Books'
}